<div class="card">
    <div class="grid">
        <div class="col-12 lg:col-8">
            <div class="flex flex-column p-fluid">
                <p-editor (onTextChange)="textChange($event)" [style]="{'height':'250px'}"></p-editor>
            </div>
        </div>
    </div>
</div>
<div>
    HTML Code :
    <br>
    {{html}}
</div>
<br>
Visual Preview:
<br>
<div [innerHTML]="html">
</div>